<template>
  <div class="ubox">
    <el-avatar :size="80" class="">
      <el-icon :size="50" >
        <UserFilled />
      </el-icon>
    </el-avatar>
    <div class="uinfo">
        <div class="uinfo-1">{{hello}}</div>
        <div class="uinfo-2">{{user}}</div>
    </div>
  </div>
  <!-- <div>
    <el-radio-group v-model="radio1" size="large">
      <el-radio-button label="1"><el-icon :size="30"><Edit /></el-icon></el-radio-button>
      <el-radio-button label="2"><el-icon :size="30"><UserFilled /></el-icon></el-radio-button>
      <el-radio-button label="3"><el-icon :size="30"><Upload /></el-icon></el-radio-button>
    </el-radio-group>
  </div> -->
</template>

<script>
import { getHello } from '@/utils/datetime_utils'
export default {
  name: 'index',
  data () {
    return {
      hello: '',
      user: '',
      radio1: ''
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo () {
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   // spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      const { data: ret } = await this.$http.get(this.$api.userinfo)
      if (ret.status === 0) {
        const obj = ret.data
        // console.log('obj=', obj)
        this.hello = getHello() + '，' + obj.name
        this.user = obj.department + '，' + obj.role
      } else {
        this.$message.error(ret.message)
      }
      // loading.close()
    }
  }
}
</script>

<style lang="less" scoped>
  .ubox {
    padding: 16px;
    border-bottom: 1px dashed #ddd;
  }
  .uinfo {
    display:inline-block;
    margin-left: 16px;
    .uinfo-1 {
      font: 2em sans-serif;
    }
    .uinfo-2 {
      font: 1.2em sans-serif;
      color: #999;
      line-height: 40px;
    }
  }

</style>
